const maxWeight = 202;
const minWeight = 198;

const currentDateTime = Date.now();
const millisecondsInHour = 1000 * 60 * 60;
const millisecondsInDay = millisecondsInHour * 24;
const millisecondsInMonth = millisecondsInDay * 30;
const millisecondsInTwoYears = 2 * 365 * millisecondsInDay;

const WEIGHT_LOSS_FACTOR = -20 / millisecondsInTwoYears;

const demoYearData = generateYearData();
const demoMonthData = generateMonthData();
const demoWeekData = generateWeekData();

function weightLossCalculation(dateTime) {
  // Calculates the weight for a given datetime using y=mx+b
  // 200 = m * 0 + b; 180 = m * (2 * 365 * millisecondsInDay) + b
  // y = (-20/(2 * 365 * millisecondsInDay)) * x + 200; where x is the number of days between two years ago and today
  const dateTwoYearsAgo = currentDateTime - millisecondsInTwoYears;
  const calculatedWeight = WEIGHT_LOSS_FACTOR * (dateTime - dateTwoYearsAgo) + 200;
  const randomizedWeight = Math.random() * (maxWeight - minWeight) + calculatedWeight;
  return randomizedWeight;
}

function generateYearData() {
  // Generate 1 data point per month for the last 24 months, including this month
  let data = [];
  for (let i = 1; i < 24; i++) {
    const randomTime = Math.random() * millisecondsInMonth; // millisecondsInMonth is used to make yearly data more random
    const currentDataTimePoint = currentDateTime - (millisecondsInMonth * i) - randomTime;
    const currentDataWeightPoint = weightLossCalculation(currentDataTimePoint);
    data.push({
      'date': currentDataTimePoint,
      'weight': currentDataWeightPoint
    });
  }
  return data;
}

function generateMonthData() {
  // Generate 1 data point per day for the last 30 days, including this week
  let data = [];
  for (let i = 8; i < 30; i++) {
    const randomTime = Math.random() * millisecondsInDay; // millisecondsInDay is used to make monthly data more random
    const currentDataTimePoint = currentDateTime - (millisecondsInDay * i) - randomTime;
    const currentDataWeightPoint = weightLossCalculation(currentDataTimePoint);
    data.push({
      'date': currentDataTimePoint,
      'weight': currentDataWeightPoint
    });
  }
  return data;
}

function generateWeekData() {
  // Generate 1 data point per day for the last 7 days, including today
  let data = [];
  for (let i = 1; i < 7; i++) {
    const randomTime = Math.random() * millisecondsInDay; // millisecondsInDay is used to make weekly data more random
    const currentDataTimePoint = currentDateTime - (millisecondsInDay * i) - randomTime;
    const currentDataWeightPoint = weightLossCalculation(currentDataTimePoint);
    data.push({
      'date': currentDataTimePoint,
      'weight': currentDataWeightPoint
    });
  }
  return data;
}

export const demoData = demoWeekData.concat(demoMonthData, demoYearData);